/* eslint-disable */
import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    CardContent,
    Grid,
    InputAdornment,
    Stack,
    Table,
    TableBody,
    TableContainer,
    TablePagination,
    TextField,
    Tooltip,
    Typography,
    useTheme
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import MainCard from './MainCard';
import { useDispatch, useSelector } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
// import { TermsActions } from 'store/slices/Terms&Condition';
import EnhancedTableHead from './ListingTableHead';
import SkeletonDocument from 'ui-component/skeleton/SkeletonDocuments';
import ListingTableRow from './ListingTableRow';
import EmptyContent from 'ui-component/extended/EmptyContent';
import useTable, { getComparator } from 'hooks/useTable';
import DetailsModal from './DetailsModal';
import { openSnackbar } from 'store/slices/snackbar';
import { openConfirmationModal } from 'store/slices/confirmationModal';
import { findKeyInObject } from 'utils/findKeyInObjects';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import useDebounce from 'hooks/useDebounce';
import ShareAccess from './ShareAccess';
import { propertyStatus, roles } from 'store/constant';
import { applySortFilter } from 'views/attendance/leave';
import useAuth from 'hooks/useAuth';
import { EmployeeActions } from 'store/slices/employees';
import { clearManageListingFilters, setManageListingFilters, toggleArchieveBtnFalse } from 'store/slices/customActions';

const ArchievedListing = () => {
    const { listings, loading, totalData, complexDropdown, floorPlanDropdown } = useSelector((state) => state.listings);
    const { fetchAllListings, deleteListings, editListingStatus, getCount, duplicateListings, updateArchieveListing } = ListingActions;
    const { search, selectedAM, selectedFilter, selectedComplex, selectedFloorPlan } = useSelector(
        (state) => state.customActions.manageListing
    );
    const { fetchEmployeeContacts } = EmployeeActions;
    const { isArchivedBtnClicked } = useSelector((state) => state.customActions);

    // const { listings, loading, totalData, count,  } = useSelector((state) => state.listings);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { role, user } = useAuth();
    const theme = useTheme();
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [openDetails, setOpenDetails] = useState(false);
    const [openShareAccess, setOpenShareAccess] = useState({ open: false, id: '' });
    // const [search, setSearch] = useState(null);
    const tableRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [allAMS, setAllAMS] = useState([]);
    const allFilters = ['Floor Plan', 'Complex Name', 'Unit Id', 'Listing Price', 'Photos'];

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - tableRef.current.offsetLeft);
        setScrollLeft(tableRef.current.scrollLeft);
    };

    const handleMouseLeaveOrUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tableRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust the multiplier for scroll speed
        tableRef.current.scrollLeft = scrollLeft - walk;
    };

    const {
        page,
        order,
        orderBy,
        rowsPerPage,
        setPage,
        selected,
        setSelected,
        onSelectRow,
        onSelectAllRows,
        setOrder,
        setOrderBy,
        // onSort,
        onChangePage,
        onChangeRowsPerPage
    } = useTable();

    const onSort = (id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const debouncedSearch = useDebounce(search, 500);

    useEffect(() => {
        let filterParam = '';
        if (selectedFilter) {
            if (selectedFilter === 'Floor Plan') {
                filterParam = 'generalInformation->floorPlanName';
            } else if (selectedFilter === 'Complex Name') {
                filterParam = 'generalInformation->complexName';
            } else if (selectedFilter === 'Unit Id') {
                filterParam = 'locationInformation->unit';
            } else if (selectedFilter === 'Listing Price') {
                filterParam = 'listingInformation->listPrice';
            } else if (selectedFilter === 'Photos') {
                filterParam = 'attachments';
            }
        }
        dispatch(
            fetchAllListings({
                page: page + 1,
                limit: rowsPerPage,
                search,
                status: propertyStatus?.ARCHIEVED,
                managerId: selectedAM,
                filters: filterParam || '',
                complex: selectedComplex,
                floorPlan: selectedFloorPlan,
                sortByKey: orderBy !== '' && orderBy !== 'name' ? orderBy : null,
                sortByType: order !== '' ? order : null
            })
        );
    }, [order, orderBy, page, rowsPerPage, debouncedSearch, selectedAM, selectedFilter, selectedComplex, selectedFloorPlan]);

    const fetchDataAfterMultiDelete = () => {
        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search, status: propertyStatus?.ARCHIEVED }));
    };

    useEffect(() => {
        setTableData(listings);
    }, [listings]);

    const detailedView = (row) => {
        setOpenDetails(true);
        setSelectedRow(row);
    };

    const handleArchieve = async (row) => {
        const data = {
            id: row?.id,
            values: {
                status: propertyStatus.DEFAULT
            }
        };
        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Please click on submit to unarchive the property',
                handleConfirm: async (listNumber) => {
                    const newData = {
                        ...data,
                        listingId: listNumber
                    };
                    const res = await dispatch(editListingStatus(data));
                    await dispatch(getCount());
                    if (res?.payload?.status === 201 || res?.payload?.status === 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Property archieved successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search, status: propertyStatus?.ARCHIEVED }));
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message:
                                    findKeyInObject(res?.payload?.error, `message`) ||
                                    findKeyInObject(res?.payload?.error, `error`) ||
                                    'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const handleApproveArchieveRequest = async (row, status) => {
        const data = { property_id: row?.id, archiveStatus: status };

        dispatch(
            openConfirmationModal({
                open: true,
                message: `Please click on submit to ${status === 'APPROVED' ? 'approve' : 'reject'} the archive request`,
                listingNumber: row?.listing_id ? row?.listing_id : row?.id?.slice(-5),
                islistingNumber: row?.listing_id ? true : false,
                handleConfirm: async (listNumber) => {
                    const res = await dispatch(updateArchieveListing(data));
                    dispatch(getCount());
                    if (res?.payload?.status === 201 || res?.payload?.status === 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Request approved successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search, status: propertyStatus?.ARCHIEVED }));
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message:
                                    findKeyInObject(res?.payload, `message`) ||
                                    findKeyInObject(res?.payload, `error`) ||
                                    'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const handleDelete = async (Id) => {
        const object = {
            properties: [Id]
        };

        dispatch(
            openConfirmationModal({
                open: true,
                message: 'This action is not reversible.',
                islistingNumber: true,
                handleConfirm: async () => {
                    const res = await dispatch(deleteListings(object));

                    if (res?.payload?.status !== 201 && res?.payload?.status !== 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: res?.payload?.message || 'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Property deleted successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        dispatch(fetchAllListings({ page: page + 1, limit: rowsPerPage, search: null, status: propertyStatus?.ARCHIEVED }));
                    }
                }
            })
        );
    };

    const handleAnalyticsOpen = (row) => {
        navigate(`/dashboard/analytics/${row?.id}`);
    };

    const handleDuplicate = async (id) => {
        dispatch(
            openConfirmationModal({
                open: true,
                message: 'Are you sure you want to create a new listing?',
                islistingNumber: true,
                handleConfirm: async () => {
                    const res = await dispatch(duplicateListings(id));

                    if (res?.payload?.status !== 201 && res?.payload?.status !== 200) {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: res?.payload?.message || 'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'New Property Created successfully',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );
                        navigate('/listing/manage-listing');
                        // navigate(`/listing/${res?.payload?.data?.id}`);
                    }
                }
            })
        );
    };

    const createNewComplexDuplicateLisitng = async (initialValues) => {
        try {
            const filteredObject = {};

            // Add the completion key-value pair
            filteredObject['completion'] = 72;

            let res = await dispatch(createEmptyListings(filteredObject));

            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                navigate(`/listing/${res?.payload?.data?.id}`);
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message:
                            findKeyInObject(res?.payload, `message`) ||
                            findKeyInObject(res?.payload, `error`) ||
                            `Oops! Something went wrong.`,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    })
                );
            }
        } catch (e) {
            // // console.log({ e });
            dispatch(
                openSnackbar({
                    open: true,
                    // message:
                    //     findKeyInObject(res?.payload, `message`) || findKeyInObject(res?.payload, `error`) || `Oops! Something went wrong.`,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    };

    const handleEdit = (row) => {
        navigate(`/listing/${row?.id}`);
    };

    const dataFiltered = applySortFilter({
        tableData: tableData?.map((row) => ({
            ...row,
            specialAccessUserNames: row?.specialUserAccess
                ?.filter((e) => e?.user?.roleName === roles.APARTMENT_MANAGER)
                ?.map((e) => `${e?.user?.firstName} ${e?.user?.lastName}`)
                .join(', ')
        })),
        comparator: getComparator(order, orderBy)
    });

    const handleClearFilter = async () => {
        await dispatch(clearManageListingFilters());
        setOrderBy('');
        setOrder('');
    };

    const [searchParams] = useSearchParams();

    useEffect(() => {
        dispatch(fetchEmployeeContacts({ search: '' })).then((data) => {
            setAllAMS(data?.payload?.primaryData);
        });

        const am = searchParams.get('am');
        if (am) {
            dispatch(setManageListingFilters({ selectedAM: am || null }));
            // setSelectedAM(am);
        }
    }, [searchParams]);

    console.log(isArchivedBtnClicked);

    useEffect(() => {
        if (isArchivedBtnClicked === true) {
            dispatch(toggleArchieveBtnFalse());
        } else {
            dispatch(clearManageListingFilters());
        }
    }, []);

    return (
        <>
            {/* {Object.keys(terms).length > 0 && !terms?.userAgreement && <TermModal />} */}
            <Breadcrumbs heading="Archived Listings" links={[{ name: 'Listings', href: '/listing/archived-listing' }]} />
            <DetailsModal open={openDetails} setOpen={setOpenDetails} selectedRow={selectedRow} />
            <MainCard title="Archived Listings" contentSX={{ p: 0 }}>
                <CardContent>
                    <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                        <Box
                            sx={{ display: 'flex', width: '100%', flexDirection: ['column', 'column', 'row'] }}
                            direction="row"
                            gap={1}
                            alignItems="center"
                        >
                            {/* Search TextField */}
                            <Box sx={{ display: 'flex', gap: 1, width: '85%', flexDirection: ['column', 'column', 'row'] }}>
                                <TextField
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small" sx={{ color: '#462F4D' }} />
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            borderRadius: '8px',
                                            padding: '6px'
                                        }
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    value={search}
                                    size="small"
                                    onChange={(e) => {
                                        dispatch(setManageListingFilters({ search: e?.target?.value || '' }));
                                    }}
                                    placeholder="Search By Complex Name, Listing ID and Address"
                                />

                                {role !== roles.APARTMENT_MANAGER && (
                                    <Autocomplete
                                        fullWidth
                                        id="employement_type"
                                        options={allAMS?.filter((am) => am?.status === 'VERIFIED') || []}
                                        getOptionLabel={(option) => (option?.firstName ? `${option.firstName} ${option.lastName}` : '')} // only name
                                        value={allAMS?.find((am) => am?.id === selectedAM) || null}
                                        onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedAM: newValue?.id || null }))}
                                        renderInput={(params) => <TextField {...params} label="Select Manager" />}
                                        renderOption={(props, option) => (
                                            <Box
                                                {...props}
                                                sx={{
                                                    display: 'flex !important',
                                                    flexDirection: 'column !important',
                                                    alignItems: 'start !important',
                                                    textAlign: 'left !important',
                                                    justifyContent: 'start !important'
                                                }}
                                            >
                                                <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                    {`${option.firstName} ${option.lastName}`}
                                                </Typography>
                                            </Box>
                                        )}
                                    />
                                )}
                                {role === roles.ADMIN && (
                                    <Autocomplete
                                        fullWidth
                                        id="employement_type"
                                        options={allFilters || []}
                                        value={allFilters?.find((am) => am === selectedFilter) || null}
                                        onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedFilter: newValue || null }))}
                                        renderInput={(params) => <TextField {...params} label="Last Update By" />}
                                        renderOption={(props, option) => (
                                            <Box
                                                {...props}
                                                sx={{
                                                    display: 'flex !important',
                                                    flexDirection: 'column !important',
                                                    alignItems: 'start !important',
                                                    textAlign: 'left !important',
                                                    justifyContent: 'start !important'
                                                }}
                                            >
                                                <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                    {option}
                                                </Typography>
                                            </Box>
                                        )}
                                    />
                                )}
                                <Autocomplete
                                    fullWidth
                                    id="employement_type"
                                    options={complexDropdown || []}
                                    value={complexDropdown?.find((am) => am === selectedComplex) || null}
                                    onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedComplex: newValue }))}
                                    renderInput={(params) => <TextField {...params} label="Select Complex" />}
                                    renderOption={(props, option) => (
                                        <Box
                                            {...props}
                                            sx={{
                                                display: 'flex !important',
                                                flexDirection: 'column !important',
                                                alignItems: 'start !important',
                                                textAlign: 'left !important',
                                                justifyContent: 'start !important'
                                            }}
                                        >
                                            <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                {option}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                                <Autocomplete
                                    fullWidth
                                    id="employement_type"
                                    options={floorPlanDropdown || []}
                                    value={floorPlanDropdown?.find((am) => am === selectedFloorPlan) || null}
                                    onChange={(e, newValue) => dispatch(setManageListingFilters({ selectedFloorPlan: newValue }))}
                                    renderInput={(params) => <TextField {...params} label="Select Floor Plan" />}
                                    renderOption={(props, option) => (
                                        <Box
                                            {...props}
                                            sx={{
                                                display: 'flex !important',
                                                flexDirection: 'column !important',
                                                alignItems: 'start !important',
                                                textAlign: 'left !important',
                                                justifyContent: 'start !important'
                                            }}
                                        >
                                            <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
                                                {option}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                            </Box>

                            {role !== roles.APARTMENT_MANAGER && (
                                <Tooltip title="Clear Filters">
                                    <Button onClick={handleClearFilter}>
                                        <Typography
                                            align="left"
                                            variant="subtitle1"
                                            component="div"
                                            sx={{ color: '#0E7AF0', fontWeight: '600', fontSize: '12px' }}
                                        >
                                            Clear Filters
                                        </Typography>

                                        <CloseIcon sx={{ marginLeft: '5px', color: '#0E7AF0', fontSize: '12px' }} />
                                    </Button>
                                </Tooltip>
                            )}
                        </Box>

                        <ShareAccess
                            openDialog={openShareAccess?.open}
                            handleCloseDialog={() => {
                                setOpenShareAccess({ open: false, id: '' });
                            }}
                            listingId={openShareAccess?.id}
                        />
                    </Grid>
                </CardContent>

                <TableContainer
                    sx={{ mt: 3 }}
                    style={{ maxWidth: '100%', overflowX: 'auto', cursor: isDragging ? 'grabbing' : 'grab' }}
                    ref={tableRef}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseLeaveOrUp}
                    onMouseLeave={handleMouseLeaveOrUp}
                    className="custom-scrollbar"
                >
                    <Table>
                        <EnhancedTableHead
                            numSelected={selected?.length}
                            order={order}
                            orderBy={orderBy}
                            setSelected={setSelected}
                            onSelectAllClick={(checked) =>
                                onSelectAllRows(
                                    checked,
                                    tableData?.map((row) => row?.id)
                                )
                            }
                            selected={selected}
                            onSort={onSort}
                            rowCount={tableData?.length}
                            theme={theme}
                            fetchDataAfterMultiDelete={fetchDataAfterMultiDelete}
                            archieved={true}
                        />
                        <TableBody>
                            {loading
                                ? [1, 2, 3, 4, 5].map((ele, index) => <SkeletonDocument key={ele + index} />)
                                : dataFiltered.map((row, index) => (
                                      <ListingTableRow
                                          key={row?.id}
                                          row={row}
                                          index={page * rowsPerPage + index}
                                          selected={selected}
                                          onSelectRow={onSelectRow}
                                          detailedView={detailedView}
                                          handleDelete={handleDelete}
                                          handleArchieve={handleArchieve}
                                          handleEdit={handleEdit}
                                          handleDuplicate={handleDuplicate}
                                          handleAnalyticsOpen={handleAnalyticsOpen}
                                          openShareAccess={(e) => {
                                              setOpenShareAccess({ open: true, id: e });
                                          }}
                                          createNewComplexDuplicateLisitng={createNewComplexDuplicateLisitng}
                                          handleApproveArchieveRequest={handleApproveArchieveRequest}
                                      />
                                  ))}
                        </TableBody>
                    </Table>
                    {!loading && tableData?.length === 0 && <EmptyContent title="No Lisings found!" />}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    component="div"
                    count={totalData || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={onChangePage}
                    onRowsPerPageChange={onChangeRowsPerPage}
                />
            </MainCard>
        </>
    );
};

export default ArchievedListing;
